import type { Phrases } from './Phrases.d';


import { faImage } from '@fortawesome/pro-light-svg-icons';
// import { FileUpload as FriskFileUpload } from '@hdir/ui/file-upload';
import React /* , { useEffect, useRef } */ from 'react';
import {
	type FieldValues,
	type FieldPath,
	// useController,
} from 'react-hook-form';

// import { forceArray } from '/lib/helsecore/forceArray';
// import { Div, Span } from '/react4xp/components/Element';
// import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';

import { FileUpload } from '../../../components/react-hook-form/FileUpload';
import { COMMON_FIELD_NAME } from './constants';


export const SIXTY_MB_IN_BYTES = 1000*1000*60; // 60 MB (metric)


export const ImageUpload = <
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const name = COMMON_FIELD_NAME.IMAGES as TName;
	const label = phrases['notificationForm.common.imageField.label'];
	// const description = phrases['notificationForm.common.imageField.boxText'];

	// const {
	// 	control,
	// 	getRequired,
	// 	setErrorSummaryLabel,
	// 	setFocusRef,
	// 	setScrollRef,
	// } = useFormContext<TFieldValues>();

	// const required: boolean = getRequired(name);

	// const {
	// 	field: {
	// 		// disabled,
	// 		onChange: useControllerOnChange,
	// 		// ref,
	// 		value,
	// 	},
	// 	fieldState: {
	// 		error: fieldStateError,
	// 	},
	// } = useController<TFieldValues, TName>({
	// 	control,
	// 	// disabled: disabledProp,
	// 	name,
	// });
	// console.debug('fieldStateError', fieldStateError);

	// const uploadedFiles = forceArray(value) as File[];

	// const focusRef = useRef<HTMLInputElement>();
	// const scrollRef = useRef<HTMLDivElement>();

	// const errorSummaryLabel = label;
	// useEffect(() => {
	// 	if (errorSummaryLabel) {
	// 		setErrorSummaryLabel({field: name, label: errorSummaryLabel});
	// 	}
	// },[errorSummaryLabel]);

	// useEffect(() => {
	// 	if (focusRef.current) {
	// 		setFocusRef({ field: name, el: focusRef.current });
	// 	}
	// },[focusRef.current]);

	// useEffect(() => {
	// 	if (scrollRef.current) {
	// 		setScrollRef({ field: name, el: scrollRef.current });
	// 	}
	// },[scrollRef.current]);

	return (
		// <Div
		// 	elementRef={scrollRef}
		// >
		// 	<FriskFileUpload
		// 		acceptFiletypes={['image/jpeg', 'image/png']}
		// 		// capture='environment' // TODO: Frisk BUG, doesn't become attribute, nor text translations.
		// 		description={description}
		// 		// error={error}
		// 		error={fieldStateError ? fieldStateError.message : null}
		// 		fullWidth={true}
		// 		label={
		// 			<Span
		// 				className='font-semibold text-xl'
		// 				elementRef={focusRef}
		// 			>
		// 				{label}
		// 			</Span>
		// 		}
		// 		multipleFilesAllowed
		// 		name={name}
		// 		onFileUpdate={useControllerOnChange}
		// 		perFileSizeLimitMb={60}
		// 		// ref={ref} // TODO: FRISK BUG, forwardRef is not connected to inputRef!
		// 		required={required}
		// 		totalSizeLimitMb={60}
		// 		uploadedFiles={uploadedFiles}
		// 	/>
		// </Div>
		<FileUpload
			accept={['image/jpeg', 'image/png']}
			boxText={phrases['notificationForm.common.imageField.boxText']}
			buttonText={phrases['notificationForm.common.imageField.buttonText']}
			// capture='environment' // Don't know why this wasn't here?
			fileListHeading={phrases['notificationForm.common.imageField.fileListHeading']}
			icon={faImage}
			label={label}
			// max={3}
			name={name}
			multiple
			subtleText={phrases['notificationForm.common.imageField.subtleText']}
			totalSizeLimit={SIXTY_MB_IN_BYTES}
		/>
	);
};
